const SERVICES_WITH_NODE_SCALING = {
  Elasticsearch: {
    dedicated_master: {
      minQuantity: 3,
      maxQuantity: 3,
    },
    elasticsearch: {
      minQuantity: 1,
      maxQuantity: 5,
    },
  },
  CockroachDB: {
    cockroachdb: {
      minQuantity: 3,
      maxQuantity: 8,
    },
  },
};

export default SERVICES_WITH_NODE_SCALING;
